import React from "react";

function Label({ className = "", check = false, children, ...props }) {
  const classes = [
    check ? "inline-flex items-start" : "block",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <label className={classes} {...props}>
      {children}
    </label>
  );
}

export default Label;
